import style from "./style.module.scss";
import MainSharedComponent from "../mainSharedComponent";
import { motion } from "framer-motion";
import { DomainInfo } from "@components/severalbrands/utils/services";
const performanceBasedDigitalMarketing = {
    img: "/severalbrands/assets/images/performanceBasedImg2.png",
    mainTitle: "What Shapes Our Identity",
    paragraphs: [
        "Several Brands started with one question: what if lead generation were built entirely around transparency and measurable performance, instead of the industry norms everyone else defaults to? Every campaign, every report, and every client relationship since has been our answer.",
    ],
    secondSectionClassName: style["secondSectionClassName"],
    mainSectionClassName: `${style["boxShadow"]}`,
    mainTitleClassName: "text-[#fff]",
    textClassName: "text-[#fff]",
    imgClassName:
        "w-[270px]  h-[250px] md:w-[413px] md:min-w-[413px] md:h-[409px]  3xl:w-[613px] 3xl:min-w-[613px] 3xl:h-[609px]  relative lg:-mt-[140px] 3xl:-mt-[80px]",
};

export default function FirstSection({
    domainInfo,
}: {
    domainInfo: DomainInfo;
}) {
    return (
        <section>
            <motion.div
                transition={{ duration: 1.5 }}
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="px-4 lg:px-0"
            >
                <h1 className="font-bold text-[#351C4F] 3xl:text-8xl 3xl:leading-[5.5rem] lg:text-6xl lg:leading-[4.5rem] text-4xl leading-10 text-center">
                    Our Story
                </h1>
                <p className="3xl:mt-7 mt-5 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1350px] max-w-[853px] mx-auto text-center font-light">
                    We combine decades of hands-on marketing expertise and
                    nationwide reach to deliver high-intent leads that are ready
                    to engage. Since 2020, our mission has been to connect
                    businesses with their target market through
                    performance-driven campaigns. Hundreds of partners now trust
                    us to strengthen their sales pipeline transparently.
                </p>
            </motion.div>
            <div className=" 3xl:mt-36 lg:mt-28 mt-14 ">
                <MainSharedComponent
                    info={performanceBasedDigitalMarketing}
                    domainInfo={domainInfo}
                />
            </div>
        </section>
    );
}
